module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "center-panel",
    attrs: {
      "id": "page__additional-services"
    }
  }, [_c('md-content', {
    attrs: {
      "md-theme": "white",
      "loading": _vm.progress
    }
  }, [_c('AdditionalServicesMenu'), _vm._v(" "), _c('sort-table', {
    attrs: {
      "columns": _vm.tableColumns,
      "per-page": _vm.perPage,
      "link": "",
      "total": _vm.additional_services_amount,
      "table-id": "price-services",
      "tableHeight": "calc(100% - 48px)"
    },
    on: {
      "refresh": _vm.getServices,
      "create": _vm.addService
    },
    scopedSlots: _vm._u([{
      key: "markup_type",
      fn: function(scope) {
        return [_c('span', [_vm._v(" " + _vm._s((scope.item.markup_type === '2') ? 'Процентная' : 'Числовая') + " ")])]
      }
    }, {
      key: "active",
      fn: function(scope) {
        return [_c('span', [_vm._v(" " + _vm._s((scope.item.active === '1') ? 'Да' : 'Нет') + " ")])]
      }
    }, {
      key: "section",
      fn: function(scope) {
        return [(_vm.sections[scope.item.section]) ? _c('span', [_vm._v(" " + _vm._s(_vm.sections[scope.item.section]) + " ")]) : _c('span', [_vm._v(" Не указан ")])]
      }
    }, {
      key: "actions",
      fn: function(scope) {
        return [_c('z-icon-button', {
          attrs: {
            "icon": ['fa', 'trash'],
            "danger-light": "",
            "rounded": ""
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              $event.preventDefault();
              _vm.onRemove(scope.item.id)
            }
          }
        })]
      }
    }]),
    model: {
      value: (_vm.services),
      callback: function($$v) {
        _vm.services = $$v
      },
      expression: "services"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b88b267c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/cost/views/additional_services/AdditionalServices.vue
// module id = 1247
// module chunks = 0